export const getExtension = (fileName) => {
    const splitString = fileName.split('.');
    const extension = splitString.length >= 2 ? splitString[splitString.length - 1] : 'desconocido';
    return (extension || '').trim().toLowerCase();
};
export const getMimeType = () => {
    // const extension = getExtension(fileName);
    // const mimeType = mime.lookup(extension);
    // return mimeType;
    return "";
};
export const readAllText = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsText(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
};
